import { Schema as S } from "effect";

/**
 * Request schema for fetching patient medication history
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const req: MedicationHistoryRequest = { patientId: "abc123" }
 * ```
 */
export const MedicationHistoryRequestSchema = S.Struct({
  patientId: S.String,
});

export type MedicationHistoryRequest = S.Schema.Type<
  typeof MedicationHistoryRequestSchema
>;
